import gsap from 'gsap';

import case01 from './public/images/case-01-02-opt.jpeg';
import case02 from './public/images/case-01-01.jpeg';

import { Link } from "react-router-dom";

import { useEffect } from 'react';
import { motion as m } from 'framer-motion';

export default function About() {


  useEffect(() => {
    window.scrollTo(0, 0);
    const tl = gsap.timeline({});

    // Set the initial state of the panel_line
    gsap.set('.panel__line', {
      transformOrigin: "center center",
      scaleY: 0,
      ease: 'linear'
    });
    // Set the initial state of the logo.
    gsap.set('.panel__name__logo', {
      x: 200,
    });
    // Set the initial state of the copy.
    gsap.set('.panel__name__copy', {
      x: -320,
    });
    // Set the initial state of the btn.
    gsap.set('.intro__btn', {
      y: 320,
    });

    const scaleLine = gsap.to('.panel__line', {
      scaleY: .6
    });
    const moveLogo = gsap.to('.panel__name__logo', {
      x: 0,
      ease: 'ease.in',
      duration: 1,
      delay: 0.5
    });
    const moveCopy = gsap.to('.panel__name__copy', {
      x: 0,
      ease: 'ease.in',
      duration: 1,
      delay: 0.5
    });
    const moveIntroBtn = gsap.to('.intro__btn', {
      y: 0,
      ease: 'ease.in',
      duration: 1,
      delay: 0.5
    });

    tl.
      add(scaleLine).
      add([moveLogo, moveCopy, moveIntroBtn]);

  }, []);

  return (
    <m.div className="about"
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      transition={{delay: .25, duration: .5, ease: 'easeOut'}}>
      <div className="about__wrapper">

        <div className="about__header about__container">
          <div><span className="bold">PNDR</span> Cases | Ambev Brazil</div>
          <div>
            <div className="home__btn">
              <Link to="/" className="home__btn btn" state={{hideIntro: true}}>
                Home
              </Link>
              {/* <a href="/" className="home__btn btn">
                <span>Home</span>
              </a> */}
            </div>
          </div>
        </div>

        <div className="about__featured__photo about__container">
          <img src={case01} />
        </div>

        <div className="about__text__container about__container">

          <div className="about__text__menu">
            <div className="about__menu__top">
              <div className="text__menu__item">
                <div className="menu__bold">Client</div>
                <div className="menu__text">Ambev Brazil</div>
              </div>
              <div className="text__menu__item">
                <div className="menu__bold">Category</div>
              <div className="menu__text">Product & Services</div>
              </div>
            </div>

            <div className="about__menu__bottom">
              <a href="/home">⇠ back to home</a>
            </div>
          </div>

          <div className="about__text">
            <h2 className="about__intro__title pndr__headline-2">
                Ambev Brasil
            </h2>
            <section className="about__intro">
              <div className="about__intro__container">
                <p className="about__intro__title pndr__headline-3">Vindo de um legado Cobol, projetamos a nova plataforma interna B2B para pedidos e aprovações</p>
                <p>A Ambev estava redesenhando sua plataforma logística com mais de 20 anos sediada em Cobol.
                  Mais de 20.000 pedidos por dia. Com mais de 3.000 usuários aprovando e reprovando pedidos.
                  WhatsApp e outros aplicativos de bate-papo foram considerados para chegar a uma conclusão.
                </p>
              </div>
              <div className="about__intro__container">
                <p className="about__intro__title pndr__headline-3">Briefing</p>
                <p>A Ambev estava redesenhando sua plataforma logística com mais de 20 anos sediada em Cobol.
                  Mais de 20.000 pedidos por dia. Com mais de 3.000 usuários aprovando e reprovando pedidos.
                  WhatsApp e outros aplicativos de bate-papo foram considerados para chegar a uma conclusão.
                </p>
              </div>
              <div className="about__featured__photo">
                <img src={case02} />
              </div>
            </section>
            <div className="about__stats">
              <div className="about__deliverables">
                <p className="about__intro__title pndr__headline-3">Deliverables</p>
                <ul>
                  <li>3 Personas + 3 Mapas de Empatia</li>
                  <li>Protótipo Funcional</li>
                  <li>Fluxo do Usuário + Sitemap</li>
                  <li>Protótipo Visão de Futuro</li>
                  <li>Roteiro do Produto</li>
                  <li>4 Protótipos de Painéis</li>
                  <li>Data Driven Roadmap</li>
                  <li>Entrevistas Gravadas</li>
                  <li>Toda a Documentação</li>
                </ul>
              </div>
              <div className="about__process">
                <p className="about__intro__title pndr__headline-3">Process</p>
                <ul>
                  <li>3 meses de projeto</li>
                  <li>Reuniões de imersão</li>
                  <li>Entrevistas com usuários</li>
                  <li>Desenhos de fluxo</li>
                  <li>Desenhos de protótipos</li>
                  <li>Testes de usabilidade</li>
                  <li>Pesquisa comportamental</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </m.div>

  );
}

